module.exports = __webpack_public_path__ + "img/blue_172.1905e2bf.png";